<template>
    <select v-model="selectedUser" @change="allocate" class="w-100">
        <option v-if="0 === enquiryUser || 2 === currentCategoryId" :value="0" :disabled="!canUnallocate">{{ __('Unallocated') }}</option>
        <option v-for="user in activeUsers" :value="user.id" :key="user.id">
            {{ user.username }}
        </option>
    </select>
</template>

<script>
export default {
    name: "EnqPortionUserAllocating",
    props: {
        currentCategoryId: {
            required: true,
            type: Number
        },
        enquiryUser: {
            required: true,
            type: Number
        },
        enquiryId: {
            required: true,
            type: Number
        },
        canUnallocate: {
            required: true,
            type: Boolean
        },
        returnUser: {
            required: false,
            type: Boolean,
            default: false
        },
        users: {
            required: true,
            type: Array
        },
        onAllocated: {
            required: true,
            type: Function
        }
    },
    data() {
        return {
            selectedUser: this.enquiryUser
        };
    },
    computed: {
        activeUsers() {
            var enq_id = this.enquiryUser;

            return this.users.filter(function(user) {
                return (
                    (user.has_clearance && user.departmentID === 1) ||
                    enq_id === user.id
                );
            });
        }
    },

    methods: {
        allocate(e) {
            axios
                .post("/api/enquiries/allocate", {
                    enquiryID: this.enquiryId,
                    userID: this.selectedUser,
                    returnUser: this.returnUser
                })
                .then(response => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        $("#fail-alert")
                            .text(data.message || "Unknown error")
                            .slideDown(500)
                            .delay(5000)
                            .slideUp(500);
                    } else {
                        this.onAllocated(
                            this.selectedUser,
                            data.new_user ? JSON.parse(data.new_user) : null
                        );
                    }
                })
                .catch(error => {
                    console.error(error.response);

                    $("#fail-alert")
                        .text(error || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                });
        }
    },

    watch: {
        enquiryUser: function(new_user) {
            this.selectedUser = new_user;
        }
    }
};
</script>
